/* eslint-disable react/no-unescaped-entities */
import dynamic from "next/dynamic";
import React from "react";

const AgreementPartialLayout = dynamic(
  () => import("../generic/agreement-partial-layout"),
  { ssr: false }
);

const PrivacyPolicyMain = () => {
  return (
    <AgreementPartialLayout
      title="SHIPVISTA.COM PRIVACY POLICY STATEMENT"
      subtitle="How ShipVista handles your data"
      updatedAt="Last Updated: February 1st, 2022"
    >
      {({ handleRef }) => (
        <>
          <p>
            The Privacy Policy (“Policy”) of Shipvista Corporation. DBA
            Shipvista.com ("Shipvista.com") describes the privacy practices of
            Shipvista.com and its corporate affiliates, meaning companies
            related by common ownership or control responsible for collecting
            and maintaining certain information collected about you.
            <br />
            <br />
            Shipvista.com and such corporate affiliates are collectively
            referenced as “us,” “we,” “our.” If you have questions or complaints
            regarding our privacy policy or practices, please contact us at{" "}
            <a href="mailto:privacy@shipvista.com">privacy@shipvista.com</a>.
            For general inquiries, please contact us at{" "}
            <a href="mailto:Customercare@shipvista.com">
              Customercare@shipvista.com
            </a>
            . We participate in the E.U. - U.S. Privacy Shield Framework
            (“Privacy Shield”) and comply with the Privacy Shield Principles.
            Click{" "}
            <a
              href="https://www.privacyshield.gov"
              target="_blank"
              rel="noreferrer"
            >
              https://www.privacyshield.gov
            </a>{" "}
            to learn more.
            <br />
            <br />
            We take the privacy of our customers and their downstream customers
            very seriously. We never share the information of our Customer’s
            customers under any circumstances, unless it is required to complete
            the transaction contracted with our Customer. In addition, we
            require our Customers, where applicable, to undertake to respect all
            relevant data protection laws, including the European Union General
            Data Protection Regulation (“GDPR”), the California Consumer Privacy
            Act (“CCPA”), and the state and federal law of the United States.
            This Policy applies to all personal data collected, processed, and
            stored by Shipvista.com in relation to its staff, suppliers, and
            service recipients in the course of its activities, as defined in
            GDPR and CCPA, and other relevant laws. Shipvista.com makes no
            distinction between the rights of European Union (“EU”) Data
            Subjects who are employees and those who are not. All are treated
            equally under this policy.
            <br />
            <br />
          </p>
          <ol>
            <li>
              <h5
                id="one"
                ref={
                  handleRef(
                    "1. WHEN THIS PRIVACY POLICY APPLIES.",
                    "one"
                  ) as any
                }
              >
                WHEN THIS PRIVACY POLICY APPLIES.
              </h5>
              This Policy applies to our sites, products, and services
              (collectively, "Services") that link to this Policy. Shipvista.com
              is a controller of all Personal Information subject to this Policy
              for our Services. If a Service you use links to this Privacy
              Policy, this Policy applies to you.
            </li>
            <br />
            <li>
              <h5
                id="two"
                ref={
                  handleRef(
                    "2. WHAT WE DO WITH YOUR INFORMATION.",
                    "two"
                  ) as any
                }
              >
                WHAT WE DO WITH YOUR INFORMATION.
              </h5>
              We want to be clear about what information we collect and how we
              use it to deliver our Services to you, operate our business, and
              make our Services work better for you. This Privacy Policy
              describes how we collect, use, share and secure the information
              that you provide which can be used to identify you and that is
              shared with us (“Personal Information”). It also describes your
              choices regarding the use, access, and correction of your Personal
              Information. We do not sell or share your Personal Information
              with third parties for their own commercial uses if you have opted
              out of such sharing. You may opt-out of the sharing of this
              information here: DO NOT SELL MY PERSONAL INFORMATION.
            </li>
            <br />
            <li>
              <h5
                id="three"
                ref={
                  handleRef(
                    "3. TYPES OF INFORMATION WE COLLECT.",
                    "three"
                  ) as any
                }
              >
                TYPES OF INFORMATION WE COLLECT.
              </h5>
              In connection with access to our Services, we may collect Personal
              Information, such as identifiers, personal information categories
              listed in the CCPA, internet or similar network activity, and
              Geolocation data, as described in more detail in the Privacy
              Policy Addendum for California Residents, which is available here.
              <br />
              We collect or otherwise receive information when you register or
              open an account, sign in, pay fees, purchase or otherwise use a
              Service, call us for support, or give us feedback. We may also
              obtain information from other companies or third parties, such as
              when you synchronize a third-party account or service with your
              Shipvista.com Account, or when we may use service providers to
              supplement the Personal Information you give us (e.g., validate
              your mailing address) to help us maintain the accuracy of your
              data and provide you with better service. We may collect content
              or other information that you may provide or create when you
              interact with our Services.
              <br />
              <br />
              We may automatically collect certain usage information when you
              access our Services ("Usage Data"), such as Internet Protocol
              (“IP”) addresses, log files, unique device identifiers, pages
              viewed, browser type, any links you click on to leave or interact
              with our Services, and other usage information collected from
              cookies and other tracking technologies. For example, we may
              collect IP addresses to track and aggregate retained in pseudonym
              form (replacing any directly identifying characteristics of
              personal information, to monitor the locations from which users
              navigate to our Services. We may also collect IP addresses from
              users when they log into the Services as part of our log-in and
              security features. We may also, when you enable location-based
              Services, collect Global Positioning System (GPS) location data
              and/or motion data.
              <br />
              <br />
              Our Services may change over time and we may introduce new
              features that may collect new or different types of information.
            </li>
            <br />
            <li>
              <h5
                id="four"
                ref={
                  handleRef("4. HOW WE USE YOUR INFORMATION.", "four") as any
                }
              >
                HOW WE USE YOUR INFORMATION.
              </h5>
              We may use your information, including your Personal Information,
              for the following purposes:
              <br />
              <br />
              <span>Account Registration. </span>
              We may use your name, address, phone number, billing information,
              and email address to register your account for certain Services we
              provide and to communicate important information to you. We may
              obtain additional Personal Information about you, such as address
              change information, from commercially available sources, to keep
              our records current. If you establish an administrator account
              that may be accessed by people other than you, please note that
              they may see and have the ability to change or delete your
              Personal Information. Please be careful to whom you grant
              administrators to access, as you are responsible for their
              actions.
              <br />
              <br />
              <span>To Provide Our Services and Operate Our Business.</span> We
              may use your information to operate our business, including
              providing the Services you requested, provide you with support
              related to our Services, and help us protect our Services,
              including to combat fraud and protect your information.
              <br />
              <br />
              <span>Customer Service and Technical Support.</span> We may use
              your name, address, phone number, email address, how you interact
              with our Services, and information about your computer
              configuration to resolve questions you may have about our Services
              and to follow up with you about your experience. We also offer
              various Internet chat services, for example, to speak with a
              Shipvista.com customer support representative. Internet Chat
              transmissions are encrypted, but you should not supply more
              Personal Information than is required to address your specific
              issue. A transcript of the session may be retained to resolve
              questions or issues related to our Services.
              <br />
              <br />
              <span>
                Communicate with You and Tell You About Other Services.
              </span>{" "}
              We may use your information to communicate with you about our
              Services and to give you offers for third-party products and
              services that we think may be of use to you. Please see below
              under "What You Can Do to Manage Your Privacy" for the choices you
              have regarding these communications.
              <br />
              <br />
              <span>To Improve Services and Develop New Services.</span> We will
              use your information to personalize or customize your experience
              and the Service, develop new features or services, and to improve
              the overall quality of Shipvista.com's Services.
              <br />
              <br />
              <span>Feedback.</span> We may use any information you volunteer in
              surveys you answer for us and combine them with answers from other
              customers in order to better understand our Services and how we
              may improve them. Answering any survey is optional.
              <br />
              <br />
              <span>How We Share Your Personal Information.</span> We only share
              personal information in ways that we tell you about. We do not
              sell or rent personal information to third parties and we do not
              share personal information with parties that are not owned by us
              nor under our control or direction except as described in this
              policy.
              <br />
              <span>Third-Party Service Providers.</span> We may share your
              information, including Personal Information and Usage Data, with
              third-party service providers who perform various functions to
              enable us to provide our Services and help us operate our
              business, such as website design, sending email communications,
              telephone communication, SMS (text messaging), advertising, fraud
              detection and prevention, customer care, third party surveys or
              performing analytics. These companies are authorized to use your
              personal information only as necessary to provide these services
              to us. Our contracts with these third parties require them to
              maintain the confidentiality of the Personal Information we
              provide to them, only act on our behalf and under our
              instructions, and not use Personal Information for purposes other
              than the product or service they're providing to us or on our
              behalf.
              <br />
              <br />
              <span>United States Postal Service (USPS).</span> Shipvista.com is
              regulated by the USPS. As part of the regulatory relationship,
              Shipvista.com collects certain information about you on behalf of
              the USPS. The USPS also may send us tracking data from their scans
              of your mail and packages in the mail stream. Our uses for the
              data include informing you about the status of your mail and
              packages through options like USPS Tracking, fraud detection, and
              aggregating the data to help the USPS and us provide you better
              service. To learn more about USPS postage technology and
              Shipvista.com’s relationship with the USPS, please visit the USPS
              Postage Solutions page. Information collected on behalf of USPS is
              used for the regulatory oversight function of USPS and is not used
              for other purposes.
              <br />
              <br />
              As part of Shipvista.com providing services of the USPS, Canada
              Post, UPS, FedEx, DHL, and other Carrier services, this Carrier
              services requires that you agree to their Privacy Act Statement
              and to provide information about yourself that will be maintained
              in a Privacy Act System of Records by the Postal Service.{" "}
              <span>Privacy Act Statement:</span> Your information will be used
              to facilitate the purchase of postage and fulfill transactional
              reporting requirements for postage systems. The collection is
              authorized by 39 U.S.C. 401, 403, and 404. Providing the
              information is voluntary, but if not provided, your transaction
              may not be processed. The Postal Service does not disclose your
              information to third parties without your consent, except to
              facilitate the transaction, to act on your behalf or request, or
              as legally required. This includes the following limited
              circumstances: to a congressional office on your behalf; to
              financial entities regarding financial transaction issues; to a
              Postal Service auditor; to entities, including law enforcement, as
              required by law or in legal proceedings; and to contractors and
              other entities aiding us to fulfill the Service (service
              providers). For more information regarding other specific carriers
              you may use via our Services, please see the privacy policies
              provided by each specific carrier you select.
              <br />
              <br />
              <span>
                Use of carrier services via our platform is at your own risk.
              </span>{" "}
              We are not responsible for your use of carrier services. Your use
              of carrier services is as a direct customer of the specific
              carrier of your choosing and you agree to be bound by the terms
              and conditions of that carrier for use of services. By providing
              information to certain carrier services, you understand and
              consent to the collection, use, processing disclosure, and
              transfer of such information and which they may have different
              data protection practices. Your interactions with these service
              carriers are governed by each carrier’s privacy policy.
              <br />
              <br />
              <span>Response to Subpoenas and Other Legal Requests.</span> We
              may share your information with courts, law enforcement agencies,
              or other government bodies when we have a good faith belief we're
              required or permitted to do so by law, including to meet national
              security or law enforcement requirements, to protect our company,
              or to respond to a court order, subpoena, search warrant, or other
              law enforcement request. Please see our obligations as they relate
              to European Union data subjects, in our Privacy Shield
              certification (discussed below in Section 7).
              <br />
              <br />
              <span>Protection of Shipvista.com and Others.</span> We may share
              account information, Personal Information, and Usage Data when we
              believe it is appropriate to enforce or apply our products' Terms
              of Service and other agreements; or protect the rights, property,
              or safety of Shipvista.com, our Services, our users, or others.
              For example, this includes exchanging information with other
              companies and organizations for fraud protection and credit risk
              reduction. This does not include selling, renting, sharing, or
              otherwise disclosing Personal Information of our customers for
              commercial purposes in violation of the commitments set forth in
              this Privacy Policy.
              <br />
              <br />
              <span>
                Information Sharing Between Shipvista.com Entities.
              </span>{" "}
              We share your information, including your Personal Information,
              with and among our subsidiaries, except where prohibited by law.
              Subsidiaries means companies related by common ownership or
              control. The reasons why we share your information include for our
              everyday business purposes, such as to: process your transactions,
              maintain your accounts, operate our business, etc. We may also
              share information about your transactions and experience so that
              we can operate our business effectively, detect and prevent fraud,
              and improve our Services.
              <br />
              <br />
              <span>Sharing with Third Parties Generally.</span> Shipvista.com
              may share certain information with carefully selected third
              parties that will allow them to mail you promotional materials
              about quality goods and services (including special offers and
              promotions) that may be of interest to you. The information shared
              will not include your e-mail address; your phone number; any
              information related to your postage, mailing activity, or postage
              meter license; or any information related to your customers or
              address lists. You may contact Shipvista.com at any time to
              request that your information not be shared with such third
              parties when you register with Shipvista.com, or by accessing the
              opt-out link in any email communication from Shipvista.com or by
              clicking here. Information about European Union data subjects will
              not be shared unless they have opted-in to such sharing.
              California and Nevada residents may have certain additional rights
              – see below.
              <br />
              <br />
              <span>Sale of Our Business.</span> If we sell, merge, or transfer
              any part of our business, we may be required to share your
              information. If so, you will be asked if you’d like to stop
              receiving promotional information following any change of control.
              <br />
              <br />
              <span>With your Consent.</span> Other than as set out above, we
              will provide you with notice and the opportunity to choose when
              your Personal Information may be shared with other third parties.
            </li>
            <br />
            <li>
              <h5
                id="five"
                ref={
                  handleRef(
                    "5. SYNCING, LINKING AND CONNECTING OTHER THIRD PARTY SERVICES WITH YOUR SHIPVISTA.COM SERVICE.",
                    "five"
                  ) as any
                }
              >
                SYNCING, LINKING AND CONNECTING OTHER THIRD PARTY SERVICES WITH
                YOUR SHIPVISTA.COM SERVICE.
              </h5>
              We work with other companies or developers to offer you products
              and services and you may choose to sync, link or connect other
              third-party services with your Shipvista.com Service. Sometimes
              Shipvista.com may let you know about the service or product, or
              another company may let you know about shipvista.com service or
              product. If you choose to accept these services, providing your
              consent to either the third party or to us, we may exchange your
              information, including your Personal Information, as well as
              information about how you interact with each provider’s service or
              product. This exchange of information is necessary to maintain
              business operations and to provide the ongoing service that you
              have requested. By requesting or accepting these products or
              services, you are permitting us to provide your information,
              including your Personal Information, to the other party. Prior
              consent from European Union data subjects would be required prior
              to offering any information discussed in this section.
              <br />
              <br />
              <span>WHAT YOU CAN DO TO MANAGE YOUR PRIVACY.</span> You can view
              and edit the information that identifies you online through your
              Shipvista.com Service. How you can access and control information
              that identifies you will depend on which Services you use. You
              have a choice about the use of information that identifies you,
              marketing communications you receive from us, and our use of
              cookies and other tracking technologies.
              <br />
              <br />
              <span>UPDATING YOUR PERSONAL INFORMATION.</span> In connection
              with your right to manage the Personal Information you provide to
              us, you may access, update, change, correct or request deletion of
              your information either through the Service or through our
              customer support. You can reach our customer support by using the
              contact information provided in the "How to Contact Us" section of
              this Policy. We will respond to your request within a reasonable
              time frame.
              <br />
              <span>Managing Marketing Communications from Us.</span> We will
              honor your choices when it comes to receiving marketing
              communications from us.
              <br />
              <br />
              You have the following choices if you have been receiving
              marketing communications from us that you no longer wish to
              receive:
              <br />
              <br />
              <ol>
                <li id="list">
                  You may contact Shipvista.com at any time to request that your
                  information not be shared with third parties (other than the
                  USPS) or set preferences when you register with Shipvista.com.
                </li>
                <li id="list">
                  Access the opt-out link in any email communication from
                  Shipvista.com or by clicking here.
                </li>
              </ol>
              <span>Remember</span> that even if you choose not to receive
              marketing communications from us, we will continue to send you
              mandatory service or transactional communications.
              <br />
              <span>European Union data subjects</span> will only receive
              marketing communications from Shipvista.com or Third Parties, if
              they are affirmatively opt-in to such communication, upon
              initiating service or at another time.
              <br />
              <br />
              <span>Cookies and Other Tracking Technologies.</span> Generally,
              we use these tracking technologies to:
              <br />
              <br />
              <ol>
                <li id="list">
                  Fulfill your requests for products and services, and improve
                  our services.
                </li>
                <li id="list">
                  Remind us of who you are on return visits in order to deliver
                  to you a better and more personalized service. This cookie is
                  set when you first visit the Shipvista.com Site.
                </li>
                <li id="list">
                  Estimate our audience size and measure traffic patterns
                  regarding usage of Shipvista.com’s network of Sites. Each
                  browser accessing Shipvista.com is given a unique cookie which
                  is then used to determine the extent of repeat usage and usage
                  by a registered user versus by an unregistered user.
                </li>
                <li id="list">
                  Track the number of entries in our promotions.
                </li>
                <li id="list">
                  Customize the advertising and content you see.
                </li>
              </ol>
              If you are uncomfortable having a cookie placed on your system,
              you may elect to turn off the cookie or delete existing cookies in
              your browser. If you turn off or delete the Shipvista.com cookie,
              you may not be able to receive special offers or personalized
              content from Shipvista.com.
              <br />
              <br />
              Technologies such as cookies, or similar technologies, are used by
              Shipvista.com and our partners (e.g. network advertising
              partners), affiliates, or analytics or service providers (e.g.
              online customer support providers). These technologies are used in
              analyzing trends, administering the site, tracking user movements
              around the site, and gathering demographic information about our
              user base as a whole. We may receive reports based on the use of
              these technologies by these companies on an individual as well as
              aggregated basis.
              <br />
              <br />
              We partner with third parties to either display advertising on our
              Web site or to manage our advertising on other sites. Our
              third-party partners may use technologies such as cookies to
              gather information about your activities on this site and other
              sites in order to provide you advertising based upon your browsing
              activities and interests. If you do not wish to have this
              information used for the purpose of serving you interest-based
              ads, you May 1) clear your cache or 2) opt-out through a
              third-party service by clicking here. Please note this does not
              opt you out of being served ads. You will continue to receive
              generic ads.
              <br />
              <br />
              European Union data subjects will only have cookies placed on
              their system if they are affirmatively opt-in to such tracking.
              European Union data subjects may visit{" "}
              <a
                href="http://www.youronlinechoices.eu/"
                target="_blank"
                rel="noreferrer"
              >
                http://www.youronlinechoices.eu/
              </a>{" "}
              to understand more about Cookies and other tracking technologies
              in each European Union country.
              <br />
              <br />
              Customers in Canada may visit{" "}
              <a
                href="http://youradchoices.ca/"
                target="_blank"
                rel="noreferrer"
              >
                http://youradchoices.ca/
              </a>{" "}
              to understand more about Cookies and other tracking technologies
              in Canada.
              <br />
              <br />
              Click{" "}
              <a
                href="https://www.facebook.com/settings/?tab=ads"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>{" "}
              to opt-out of targeted ads on Facebook.
              <br />
              <br />
              Click{" "}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>{" "}
              to opt-out of Google Analytics for display advertising or to
              customize Google Display Network ads.
              <br />
              <br />
              Please note that even if you opt-out of such Cookies or otherwise
              opt-out of interest-based advertising, you will still receive
              advertisements, they just will not be tailored to your interests.
              Also, if you opt-out and later delete your cookies, use a
              different browser, or buy a new computer, you may need to renew
              your opt-out choices.
              <br />
              <br />
              <span>Do Not Track</span> - California and Delaware Notice: Our
              Services are not currently configured to respond to browsers' "Do
              Not Track" signals because at this time no formal "Do Not Track"
              standard has been adopted. However, the practices of our partners
              and other third-party providers may change as a result of this
              feature being utilized.{" "}
              <a href="https://allaboutdnt.com/">Click here</a> for more
              information on "Do Not Track."
              <br />
              <span>Social Media Features.</span> Our Services may use social
              media features, such as Facebook sharing ("Social Media
              Features"). These features may collect your IP address and which
              page you are visiting within our Service, and may set a cookie to
              enable the feature to function properly. Social Media Features are
              either hosted by a third party or hosted directly on our Services.
              Your interactions with these features are governed by the privacy
              policy of the company providing the relevant Social Media
              Features.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="six"
                ref={
                  handleRef(
                    "6. DATA RETENTION AND YOUR ACCESS RIGHTS",
                    "six"
                  ) as any
                }
              >
                DATA RETENTION AND YOUR ACCESS RIGHTS
              </h5>
              <span>Data Retention.</span> In accordance with and as permitted
              by applicable law and regulations, we will retain your information
              as long as necessary to serve you, to maintain your account for as
              long as your account is active, or as otherwise needed to operate
              our business. When you close your account, we may continue to
              communicate with you about our Services, give you important
              business updates that may affect you, and let you know about
              products and services that may interest you, unless you have opted
              out of receiving marketing communications. We may also continue to
              use some of your information for business purposes and to improve
              our offerings or in some cases to develop new ones. We will retain
              and use your information as required by applicable regulations and
              Shipvista.com's records and information management policies to
              comply with our legal and reporting obligations, resolve disputes,
              enforce our agreements, complete any outstanding transactions, and
              for the detection and prevention of fraud.
              <br />
              <span>Your Rights to Access.</span> Upon request and as required
              by applicable law, you may contact shipvista.com to confirm
              whether we maintain, or process on behalf of a third party, any of
              your Personal Information and to review it in order to verify its
              accuracy and the lawfulness of our processing of such Personal
              Information. Where you have determined that the Personal
              Information we collected about you is inaccurate or processed in
              violation of applicable law you may also request that your
              Personal Information be corrected, amended, or deleted. Requests
              for access to your Personal Information and to have it corrected,
              amended, or deleted should be sent to{" "}
              <a href="mailto:support@shipvista.com">support@shipvista.com</a>{" "}
              or to the mailing address provided under "How to Contact Us." If
              you are a California resident, please see the “Privacy Policy
              Addendum for California Residents.”
              <br />
              EU data subjects have certain rights to access Personal
              Information about them and to limit the use and disclosure of
              their Personal Information. With our Privacy Shield certification
              (discussed below in Section 7), Shipvista.com has committed to
              respect those rights. If you wish to request access, to limit use,
              or to limit disclosure, please contact us at{" "}
              <a href="mailto: privacy@shipvista.com">
                privacy@shipvista.com
              </a>{" "}
              or the mailing address provided under "How to Contact Us" and
              please provide the name of the Shipvista.com customer who
              submitted your Personal Information to our services.
              <br />
              <br />
              <span>SECURITY OF YOUR INFORMATION.</span> Keeping your
              information safe is important to us. You can find out more about
              keeping your personal information safe while online from the U.S.
              government here. We provide reasonable and appropriate security
              measures in connection with securing the Personal Information we
              collect. Though no method of transmission over the Internet, or
              method of electronic storage, is 100% secure.
              <br />
              For example, we:
              <br />
              <br />
              <ul>
                <li id="list">
                  Consistently work to update our security practices to
                  implement accepted best methods to protect your Personal
                  Information, and review our security procedures carefully.
                </li>
                <li id="list">
                  Comply with applicable laws and security standards.
                </li>
                <li id="list">
                  Securely transmit your sensitive Personal Information.
                </li>
                <li id="list">
                  Train our staff and require them to safeguard your data. Limit
                  the staff with access to your Personal Information.
                </li>
                <li id="list">
                  Transmit, store, protect, and access all cardholder
                  information in compliance with the Payment Card Industry's
                  Data Security Standards.
                </li>
              </ul>
              If you have any questions about the security of your personal
              information, you can contact us at{" "}
              <a href="mailto:support@shipvista.com">support@shipvista.com</a>
            </li>
            <br />
            <br />
            <li>
              <h5
                id="seven"
                ref={
                  handleRef("7. INTERNATIONAL DATA TRANSFERS.", "seven") as any
                }
              >
                INTERNATIONAL DATA TRANSFERS.
              </h5>
              In accordance with and as permitted by applicable law and
              regulations, we reserve the right to transfer your information,
              process, and store it outside your country of residence to
              wherever we or our third-party service providers operate. At this
              time any United States person’s data shall be stored and kept
              within the United States. European Union data subjects may have
              their data stored in the European Union or the United States, and
              such data may be transferred to the United States to allow for
              completion of the Services required. All data stored and
              transferred would be done so subject to appropriate conditions
              provided for in Chapter V of the GDPR, such as the European
              Commission Standard Contractual Clauses.
              <br />
              <br />
              <span>EU-US PRIVACY SHIELD.</span> Shipvista.com complies with the
              E.U. - U.S. Privacy Shield Framework ("Privacy Shield").
              <br />
              Although the EU-U.S. and Swiss-U.S. Privacy Shield Frameworks are
              no longer a valid basis to comply with EU and Swiss data
              protection requirements when transferring personal data from the
              European Union or Switzerland to the United States, Shipvista.com
              and its affiliates continue to participate in and have certified
              their compliance with the Privacy Shield. Shipvista.com is
              committed to subjecting all personal data, including Personal
              Information, received in the U.S. from EU member countries and the
              United Kingdom to the Privacy Shield’s applicable Principles of
              Notice, Choice, Accountability for Onward Transfer, Security, Data
              Integrity, and Purpose Limitation, Access, and Recourse,
              Enforcement, and Liability ("European and the United Kingdom
              Personal Data"). To learn more about the Privacy Shield Framework,
              and our certification hereunder, visit the U.S. Department of
              Commerce's Privacy Shield List by clicking here.
              <br />
              <br />
              Shipvista.com collects, uses, and discloses EU and the United
              Kingdom Personal Data for the purposes described in the Privacy
              Statement. The choices and means that we offer for limiting the
              use and disclosure of EU Personal Data are described above in
              Section 3, and we provide access as described in Section 4.
              Shipvista.com is responsible for the processing of EU and United
              Kingdom Personal Data that it transfers to a third party acting as
              an agent on its behalf. We remain liable in accordance with the
              Privacy Shield Principles if third-party agents that we engage to
              process such personal data on our behalf do so in a manner
              inconsistent with the Privacy Shield Principles unless we prove
              that we are not responsible for the event giving rise to the
              damage.
              <br />
              <br />
              With respect to European and United Kingdom Personal Data received
              or transferred pursuant to the Privacy Shield, Shipvista.com is
              subject to the regulatory enforcement powers of the U.S. Federal
              Trade Commission. In certain situations, Shipvista.com may be
              required to disclose European and the United Kingdom Personal Data
              in response to lawful requests by public authorities, including
              meeting national security or law enforcement requirements.
              <br />
              <br />
              Shipvista.com has further committed to cooperate with the panel
              established by the EU and the United Kingdom data protection
              authorities (DPAs) with regard to unresolved Privacy Shield
              complaints concerning human resources data transferred from the
              E.U. and the United Kingdom in the context of the employment
              relationship. E.U. and United Kingdom individuals with inquiries
              or complaints regarding HR data should first contact our Data
              Protection Officer at:{" "}
              <a href="mailto:dataprotectionofficer@shipvista.com">
                dataprotectionofficer@shipvista.com
              </a>
              . If you are a European or a resident of the European Economic
              Area and have an unresolved privacy or data use concern, you can
              contact our Data Protection Officer at{" "}
              <a href="mailto:dataprotectionofficer@shipvista.com">
                dataprotectionofficer@shipvista.com
              </a>{" "}
              or you can contact us as specified below in "How to Contact Us."
              <br />
              <br />
              Under certain conditions, more fully described on the Privacy
              Shield website, if you are a European Union or United Kingdom Data
              Subject, you may invoke binding arbitration when other dispute
              resolution procedures have been exhausted.
              <br />
              <br />
              <span>HOW TO CONTACT US.</span> If you have questions or comments
              about this Privacy Policy, please contact us. We want your
              feedback and comments.
              <br />
              <br />
              <ul>
                <li id="list">
                  <span>Via email.</span> If you have questions or complaints
                  regarding our Privacy Policy or practices, please contact us
                  by email at{" "}
                  <a href="mailto:support@shipvista.com">
                    support@shipvista.com
                  </a>
                </li>
                <li id="list">
                  <span>Via direct mail.</span> Shipvista Corporation.,
                  Attention: Privacy Policy Team: 9-9 Royalcrest Rd, Etobicoke,
                  ON M9V 2L6, CANADA
                </li>
              </ul>
              <span>CHANGES TO OUR PRIVACY POLICY.</span> From time to time we
              may change or update our Privacy Policy. We reserve the right to
              make changes or updates at any time. More information about how we
              will notify you is below.
              <br />
              If we make material changes to the way we process your Personal
              Information, we will provide you notice via our Service or by
              other communication channels, such as by email or posting on our
              Site prior to the change becoming effective. We encourage you to
              periodically review this page for the latest information on our
              privacy practices. Please review any changes carefully. If you
              object to any of the changes and no longer wish to use our
              Services, you may close your account(s). All changes are effective
              immediately upon posting and your use of our Service after a
              notice of material change or posting of an updated Privacy Policy
              shall constitute your consent to all changes.
              <br />
              <br />
              <span>
                COLLECTION AND USE OF CHILDREN'S PERSONAL INFORMATION.
              </span>{" "}
              We do not knowingly collect information from minors.
              <br />
              Shipvista.com Services are intended for and directed to adults.
              Our Services are not directed to minors and we do not knowingly
              collect Personal Information from minors.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="eight"
                ref={handleRef("8. CALIFORNIA PRIVACY RIGHTS", "eight") as any}
              >
                CALIFORNIA PRIVACY RIGHTS
              </h5>
              We do not share your Personal Information with third parties for
              their marketing purposes if you have opted out of such
              information-sharing.
              <br />
              <br />
              Please see “Privacy Policy Addendum for California Residents” for
              additional rights that you may have as a resident of California.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="nine"
                ref={handleRef("9. NEVADA PRIVACY RIGHTS", "nine") as any}
              >
                NEVADA PRIVACY RIGHTS
              </h5>
              Please see “Privacy Policy Addendum for Nevada Residents” for
              additional rights that you may have as a resident of Nevada.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="ten"
                ref={
                  handleRef(
                    "10. PRIVACY POLICY ADDENDUM FOR CALIFORNIA RESIDENTS",
                    "ten"
                  ) as any
                }
              >
                PRIVACY POLICY ADDENDUM FOR CALIFORNIA RESIDENTS
              </h5>
              This PRIVACY POLICY ADDENDUM FOR CALIFORNIA RESIDENTS supplements
              the information contained in the Privacy Policy of Shipvista
              Corporation. DBA Shipvista.com (“we,” “us,” or “our”) and applies
              solely to visitors, customers, and others who reside in the State
              of California (“consumers” or “you”). We adopt this addendum to
              comply with the California Consumer Privacy Act of 2018 (“CCPA”)
              and other California privacy laws. Any terms defined in the CCPA
              have the same meaning when used in this addendum.
            </li>
            <br />
            <li>
              <h5
                id="eleven"
                ref={handleRef("11. Information We Collect", "eleven") as any}
              >
                <u> Information We Collect</u>
                <br />
              </h5>
              <span>
                We collect information that identifies, relates to, describes,
                references, is capable of being associated with, or could
                reasonably be linked, directly or indirectly, with a particular
                consumer or device (“personal information”). In particular, we
                have collected the following categories of personal information
                from consumers within the last twelve (12) months:
                <br />
              </span>
              <table>
                <thead>
                  <tr>
                    <th>
                      Category
                      <br />
                    </th>
                    <th>
                      Examples
                      <br />
                    </th>
                    <th>
                      Collected
                      <br />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      A. Identifiers.
                      <br />
                    </td>
                    <td>
                      A real name, alias, postal address, unique personal
                      identifier, online identifier, Internet Protocol address,
                      email address, account name, or other similar identifiers.
                      <br />
                    </td>
                    <td>
                      YES
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      B. Personal information categories listed in the
                      California Customer Records statute (Cal. Civ. Code §
                      1798.80(e)).
                      <br />
                    </td>
                    <td>
                      A name, signature, address, telephone number, insurance
                      policy number, bank account number, credit card number,
                      debit card number, or any other financial information.
                      Some personal information included in this category may
                      overlap with other categories.
                      <br />
                    </td>
                    <td>
                      YES
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      C. Protected classification characteristics under
                      California or federal law.
                      <br />
                    </td>
                    <td className="auto-style1">
                      Age (40 years or older), race, color, ancestry, national
                      origin, citizenship, religion or creed, marital status,
                      medical condition, physical or mental disability, sex
                      (including gender, gender identity, gender expression,
                      pregnancy or childbirth and related medical conditions),
                      sexual orientation, veteran or military status, genetic
                      information (including familial genetic information).
                      <br />
                    </td>
                    <td className="auto-style1">
                      NO
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      D. Commercial information.
                      <br />
                    </td>
                    <td>
                      Records products or services purchased, obtained, or
                      considered, or other purchasing or consuming histories or
                      tendencies.
                      <br />
                    </td>
                    <td>
                      YES
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      E. Biometric information.
                      <br />
                    </td>
                    <td>
                      Genetic, physiological, behavioral, and biological
                      characteristics, or activity patterns used to extract a
                      template or other identifier or identifying information,
                      such as, fingerprints, faceprints, and voiceprints, iris
                      or retina scans, keystroke, gait, or other physical
                      patterns, and sleep, health, or exercise data.
                      <br />
                    </td>
                    <td>
                      NO
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      F. Internet or other similar network activity.
                      <br />
                    </td>
                    <td>
                      Browsing history, search history, information on a
                      consumer&#39;s interaction with a website, application, or
                      advertisement.
                      <br />
                    </td>
                    <td>
                      YES
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      G. Geolocation data.
                      <br />
                    </td>
                    <td>
                      Physical location or movements.
                      <br />
                    </td>
                    <td>
                      YES
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      H. Sensory data.
                      <br />
                    </td>
                    <td>
                      Audio, electronic, visual, thermal, olfactory, or similar
                      information.
                      <br />
                    </td>
                    <td>
                      NO
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      I. Professional or employment-related information.
                      <br />
                    </td>
                    <td>
                      Current or past job history or performance evaluations.
                      <br />
                    </td>
                    <td>
                      N/A
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      J. Non-public education information (per the Family
                      Educational Rights and Privacy Act (20 U.S.C. Section
                      1232g, 34 C.F.R. Part 99)).
                      <br />
                    </td>
                    <td>
                      Education records directly related to a student maintained
                      by an educational institution or party acting on its
                      behalf, such as grades, transcripts, class lists, student
                      schedules, student identification codes, student financial
                      information, or student disciplinary records.
                      <br />
                    </td>
                    <td>
                      NO
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      K. Inferences drawn from other personal information.
                      <br />
                    </td>
                    <td>
                      Profile reflecting a person&#39;s preferences,
                      characteristics, psychological trends, predispositions,
                      behavior, attitudes, intelligence, abilities, and
                      aptitudes.
                      <br />
                    </td>
                    <td>
                      NO
                      <br />
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <br />
            <li>
              <h5
                id="twelve"
                ref={
                  handleRef(
                    "12. Personal information does not include",
                    "twelve"
                  ) as any
                }
              >
                Personal information does not include:{" "}
              </h5>
              <ul>
                <li id="list">
                  Publicly available information from government records.
                  <br />
                </li>
                <li id="list">
                  De-identified or aggregated consumer information.
                  <br />
                </li>
                <li id="list">
                  Information excluded from the CCPA&#39;s scope, like:
                  <ul>
                    <li id="list">
                      health or medical information covered by the Health
                      Insurance Portability and Accountability Act of 1996
                      (HIPAA) and the California Confidentiality of Medical
                      Information Act (CMIA) or clinical trial data;
                      <br />
                    </li>
                    <li id="list">
                      personal information covered by certain sector-specific
                      privacy laws, including the Fair Credit Reporting Act
                      (FRCA), the Gramm-Leach-Bliley Act (GLBA) or California
                      Financial Information Privacy Act (FIPA), and the
                      Driver&#39;s Privacy Protection Act of 1994.
                      <br />
                    </li>
                  </ul>
                </li>
              </ul>
              <span id="categoryinfoHeader">
                We obtain the categories of personal information listed above
                from the following categories of sources:
                <br />
              </span>
              <ul>
                <li id="list">
                  Directly from our customers or our partners. For example, from
                  information customers provide to us or through our third party
                  partners, related to the services for which they engage us.
                  <br />
                </li>
                <li id="list">
                  Directly and indirectly from activity on our website (
                  <a
                    href="https://shipvista.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://shipvista.com
                  </a>
                  ), application, and/or webclient, as applicable. For example,
                  from submissions through our website portal or website usage
                  details collected automatically.
                  <br />
                </li>
                <li id="list">
                  From third parties that interact with us in connection with
                  the services we perform.
                  <br />
                </li>
              </ul>
            </li>
            <br />
            <li>
              <h5
                id="thirteen"
                ref={
                  handleRef(
                    "13. Use of Personal Information",
                    "thirteen"
                  ) as any
                }
              >
                Use of Personal Information
              </h5>
              <span>
                We may use or disclose the personal information we collect for
                one or more of the following business purposes:
                <br />
              </span>
              <ul>
                <li id="list">
                  To fulfill or meet the reason for which the information is
                  provided. For example, if you provide us with personal
                  information in order for us to prepare a shipping label, we
                  will use that information to prepare the label.
                  <br />
                </li>
                <li id="list">
                  To provide you with information, products or services that you
                  request from us.
                  <br />
                </li>
                <li id="list">
                  To provide you with email alerts and other notices concerning
                  our products or services, or events or news, that may be of
                  interest to you.
                  <br />
                </li>
                <li id="list">
                  To carry out our obligations and enforce our rights arising
                  from any contracts entered into between you and us, including
                  for billing and collections.
                  <br />
                </li>
                <li id="list">
                  To improve our website and present its contents to you.
                  <br />
                </li>
                <li id="list">
                  For testing, research, analysis and product development.
                  <br />
                </li>
                <li id="list">
                  As necessary or appropriate to protect the rights of our
                  clients or others.
                  <br />
                </li>
                <li id="list">
                  To respond to law enforcement requests and as required by
                  applicable law, court order, or governmental regulations.
                  <br />
                </li>
                <li id="list">
                  As described to you when collecting your personal information
                  or as otherwise set forth in the CCPA.
                  <br />
                </li>
                <li id="list">
                  To evaluate or conduct a merger, divestiture, restructuring,
                  reorganization, dissolution, or other sale or transfer of some
                  or all of our assets, whether as a going concern or as part of
                  bankruptcy, liquidation, or similar proceeding, in which
                  personal information held by us is among the assets
                  transferred.
                  <br />
                </li>
              </ul>
              <span>
                We will not collect additional categories of personal
                information or use the personal information we collected for
                materially different, unrelated, or incompatible purposes
                without providing you notice.
                <br />
              </span>
            </li>
            <br />
            <li>
              <h5
                id="fourteen"
                ref={
                  handleRef(
                    "14. Sharing Personal Information",
                    "fourteen"
                  ) as any
                }
              >
                Sharing Personal Information
              </h5>
              <span>
                We may disclose your personal information to a third party for a
                business purpose. When we disclose personal information for a
                business purpose, we enter a contract that describes the purpose
                and requires the recipient to both keep that personal
                information confidential and not use it for any purpose except
                performing the contract.
                <br />
              </span>
              <span>
                In the preceding twelve (12) months, we have disclosed the
                following categories of personal information for a business
                purpose:
                <br />
              </span>
              <span></span>
              <ul>
                <li id="list">
                  Category A: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Identifiers.
                </li>
                <li id="list">
                  Category B: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; California
                  Customer Records personal information categories.
                </li>
                <li id="list">
                  Category D: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Commercial
                  Information.
                </li>
                <li id="list">
                  Category F: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Internet or
                  other similar network activity
                </li>
                <li id="list">
                  Category G: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Geolocation
                  data.
                </li>
              </ul>
              <span>
                We disclose your personal information for a business purpose to
                the following categories of third parties:
                <br />
              </span>
              <ul>
                <li id="list">
                  Our affiliates.
                  <br />
                </li>
                <li id="list">
                  Service providers.
                  <br />
                </li>
                <li id="list">
                  Third-party partners in connection with products or services
                  we provide to you.
                  <br />
                </li>
              </ul>
              <span>
                In the preceding twelve (12) months, we have (i) traded limited
                identifiers (including contact name and postal address) and
                limited commercial information with a partner, and (ii) we have
                contributed limited identifiers and limited commercial
                information with marketing companies. The actions taken by us
                may be considered a “sale” under the CCPA, but we received no
                monies for trading or contributing said information.
              </span>
            </li>
            <br />
            <li>
              <h5
                id="fifteen"
                ref={handleRef("15. Your Rights and Choices", "fifteen") as any}
              >
                Your Rights and Choices
              </h5>
              The CCPA provides consumers (California residents) with specific
              rights regarding their personal information. This section
              describes your CCPA rights and explains how to exercise those
              rights.
              <br />
              <br />
              Access to Specific Information and Data Portability Rights
              <br />
              <br />
              You have the right to request that we disclose certain information
              to you about our collection and use of your personal information
              over the past 12 months. Once we receive and confirm your
              verifiable consumer request, we will disclose to you:
              <br />
              <br />
              The categories of personal information we collected about you.
              <br />
              The categories of sources for the personal information we
              collected about you.
              <br />
              Our business or commercial purpose for collecting or selling that
              personal information.
              <br />
              The categories of third parties with whom we share that personal
              information.
              <br />
              The specific pieces of personal information we collected about you
              (also called a data portability request).
              <br />
              If we sold or disclosed your personal information for a business
              purpose, two separate lists disclosing:
              <br />
              Sales, identifying the personal information categories that each
              category of recipient purchased; and
              <br />
              Disclosures for a business purpose, identifying the personal
              information categories that each category of recipient obtained.
              <br />
              Deletion Request Rights
              <br />
              <br />
              You have the right to request that we delete any of your personal
              information that we collected from you and retained, subject to
              certain exceptions. Once we receive and confirm your verifiable
              consumer request, we will delete (and direct our service providers
              to delete) your personal information from our records, unless an
              exception applies.
              <br />
              <br />
              We may deny your deletion request if retaining the information is
              necessary for us or our service providers to:
              <br />
              Complete the transaction for which we collected the personal
              information, provide a good or service that you requested, take
              actions reasonably anticipated within the context of our ongoing
              business relationship with you, or otherwise perform our contract
              with you.
              <br />
              Detect security incidents, protect against malicious, deceptive,
              fraudulent, or illegal activity, or prosecute those responsible
              for such activities.
              <br />
              Debug products to identify and repair errors that impair existing
              intended functionality.
              <br />
              Exercise free speech, ensure the right of another consumer to
              exercise their free speech rights or exercise another right
              provided for by law.
              <br />
              Comply with the California Electronic Communications Privacy Act
              (Cal. Penal Code § 1546 seq.).
              <br />
              Engage in public or peer-reviewed scientific, historical, or
              statistical research in the public interest that adheres to all
              other applicable ethics and privacy laws, when the information's
              deletion may likely render impossible or seriously impair the
              research's achievement if you previously provided informed
              consent.
              <br />
              Enable solely internal uses that are reasonably aligned with
              consumer expectations based on your relationship with us.
              <br />
              Comply with a legal obligation.
              <br />
              Make other internal and lawful uses of that information that are
              compatible with the context in which you provided it.
              <br />
              Exercising Access, Data Portability, and Deletion Rights
              <br />
              <br />
              To exercise the access, data portability, and deletion rights
              described above, please submit a verifiable consumer request to us
              by either:
              <br />
              <br />
              Calling us at (855) 434-3477
              <br />
              Emailing the request to{" "}
              <a href="mailto:privacy@shipvista.com">privacy@shipvista.com</a>
              <br />
              Only you or a person having the legal authority to act on your
              behalf may make a verifiable consumer request related to your
              personal information. You may also make a verifiable consumer
              request on behalf of your minor child.
              <br />
              <br />
              You may only make a verifiable consumer request for access or data
              portability twice within a 12-month period. The verifiable
              consumer request must:
              <br />
              <br />
              Provide sufficient information that allows us to reasonably verify
              you are the person about whom we collected personal information or
              an authorized representative.
              <br />
              Describe your request with sufficient detail that allows us to
              properly understand, evaluate, and respond to it.
              <br />
              If you are a current customer of the Company, you must log into
              your account and process any request through the application
              and/or WebClient, as applicable.
              <br />
              We may be unable to respond to your request or provide you with
              personal information if we cannot verify your identity or
              authority to make the request and confirm the personal information
              relates to you. Making a verifiable consumer request does not
              require you to create an account with us. We will only use
              personal information provided in a verifiable consumer request to
              verify the requestor's identity or authority to make the request.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="sixteen"
                ref={
                  handleRef("16. Response Timing and Format", "sixteen") as any
                }
              >
                Response Timing and Format
              </h5>
              We endeavor to respond to a verifiable consumer request within 45
              days of its receipt. If we require more time (up to 90 days), we
              will inform you of the reason and extension period in writing. If
              you have an account with us, we will deliver our written response
              to that account. If you do not have an account with us, we will
              deliver our written response by mail or electronically, at your
              option. Any disclosures we provide will only cover the 12-month
              period preceding the verifiable consumer request's receipt. The
              response we provide will also explain the reasons we cannot comply
              with a request, if applicable. For data portability requests, we
              will select a format to provide your personal information that is
              readily useable.
              <br />
              <br />
              We do not charge a fee to process or respond to your verifiable
              consumer request unless it is excessive, repetitive, or manifestly
              unfounded. If we determine that the request warrants a fee, we
              will tell you why we made that decision and provide you with a
              cost estimate before completing your request.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="seventeen"
                ref={handleRef("17. Non-Discrimination", "seventeen") as any}
              >
                Non-Discrimination
              </h5>
              <br />
              We will not discriminate against you for exercising any of your
              CCPA rights. Unless permitted by the CCPA, we will not:
              <br />
              <br />
              Deny you goods or services.
              <br />
              Charge you different prices or rates for goods or services,
              including through granting discounts or other benefits, or
              imposing penalties.
              <br />
              Provide you a different level or quality of goods or services.
              <br />
              Suggest that you may receive a different price or rate for goods
              or services or a different level or quality of goods or services.
              <br />
              Changes to Our Privacy Addendum
              <br />
              <br />
              We reserve the right to amend this privacy addendum at our
              discretion and at any time. When we make changes to this privacy
              addendum, we will notify you by email or through an addendum on
              our website homepage.
            </li>
            <br />
            <br />
            <li>
              <h5
                id="eighteen"
                ref={handleRef("18. Contact Information", "eighteen") as any}
              >
                Contact Information
              </h5>
              <br />
              If you have any questions or comments about this addendum, our
              Privacy Statement, the ways in which we collect and use your
              personal information, your choices and rights regarding such use,
              or wish to exercise your rights under California law, please do
              not hesitate to contact us at:
              <br />
              <br />
              Phone: (855) 434-3477
              <br />
              <br />
              Website:{" "}
              <a href="https://shipvista.com/" target="_blank" rel="noreferrer">
                https://shipvista.com/
              </a>
              <br />
              <br />
              Address: Shipvista.com, 9-9 Royalcrest Rd, Etobicoke, ON M9V 2L6,
              CANADA
              <br />
              <br />
              Email:{" "}
              <a href="mailto:privacy@shipvista.com">privacy@shipvista.com</a>
            </li>
            <br />
            <br />
            <li>
              <h5
                id="nineteen"
                ref={
                  handleRef(
                    "19. PRIVACY POLICY ADDENDUM FOR NEVADA RESIDENTS",
                    "nineteen"
                  ) as any
                }
              >
                PRIVACY POLICY ADDENDUM FOR NEVADA RESIDENTS
              </h5>
              This PRIVACY POLICY ADDENDUM FOR NEVADA RESIDENTS supplements the
              information contained in the Privacy Policy of Shipvista
              Corporation. DBA Shipvista.com (collectively, “we,” “us,” or
              “our”) and applies solely to visitors, customers, and others who
              reside in the State of Nevada (“consumers” or “you”).
              <br />
              <br />
              If you are a resident of Nevada, you have the right to request
              certain information from us regarding the collection and sale of
              your personal information (as defined in Nevada Revised Statutes
              603A.320) during your visit to our websites or when you otherwise
              interact with us online. If you have sought or acquired, by
              purchase or lease, any goods or services for personal, family, or
              household purposes from our us, you may ask us to disclose whether
              we have sold (for a monetary consideration) certain information
              about you (including your first and last name, physical address,
              email address, telephone number, social security number, an
              identifier that allows you to be contacted either physically or
              online, or other contact information that allows us to identify
              you personally).
              <br />
              <br />
              As a Nevada resident, you may also request to opt-out of us
              sharing such information about you. To make this inquiry, please
              submit a request in writing to{" "}
              <a href="mailto:privacy@shipvista.com">
                privacy@shipvista.com
              </a>{" "}
              with “Nevada Privacy Rights” in the subject line. You must include
              your full name, email address, account number and attest that you
              are a Nevada resident by providing a Nevada postal address in your
              request. Please state whether you are requesting information
              and/or opting out. We will respond to your request within 60 days
              or let you know if we need additional time. We may require
              additional information to verify your identity before we can
              respond.
            </li>
          </ol>
        </>
      )}
    </AgreementPartialLayout>
  );
};

export default PrivacyPolicyMain;
